<template>
	<div class="ReActionInput" :class="[{'my_borders':showBordes}]">
		<div class="mr-2">
			<input type="text" :placeholder="placeholder" class="form-control" v-model.lazy="value">
		</div>
		<div class="actions">
			<template v-for="(action,act_index) in  masActions">
				<base-switch v-if="action.actionType == 'switcher'" :key="act_index"
					v-model="action.action_model"
					type="primary"
					:on-text="action.label_on"
					:off-text="action.label_off"
					@change="DoApi(action)"
				></base-switch>
				<button v-if="action.actionType == 'btn_custom'" :key="act_index" class="ml-2 btn btn-icon btn-simple btn-info" @click="DoApi(action)">
					<i class="tim-icons" :class="action.icon"></i>
				</button>
				<button v-if="action.actionType == 'btn_att'" :key="act_index" class="ml-2 btn btn-icon btn-simple btn-info" @click="DoAtt(action)">
					<i class="tim-icons icon-attach-87"></i>
				</button>
				<button v-if="action.actionType == 'btn_edit'" :key="act_index" class="ml-2 btn btn-icon btn-simple btn-primary" @click="DoApi(action)">
					<i class="tim-icons icon-pencil"></i>
				</button>
				<button v-if="action.actionType == 'btn_del'" :key="act_index" class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoApi(action)">
					<i class="tim-icons icon-trash-simple"></i>
				</button>
			</template>
		</div>
	</div>
</template>

<script>
	/*
		[{
			actionType: 'switcher',
			action_model: false,
			label_on: 'Вкл',
			label_off: 'Выкл',
			onClickApi: {apiMethod:'ENABLE_DISABLE',apiParam:{obj:'BP'}},
		},
		{
			actionType: 'btn_custom',
			icon: 'icon-settings-gear-63',
			onClickApi: {apiMethod:'COSTOM_ACTION',apiParam:{obj:'BP'}},
		},
		{
			actionType: 'btn_edit',
			onClickApi: {apiMethod:'GOTO',apiParam:{obj:'local',to:'/data/settings/bp_editor/id/1/edit'}},
		},
		{
			actionType: 'btn_del',
			onClickApi: {apiMethod:'DEL_ACTION',apiParam:{obj:'BP'}},
		}],
	*/
	import { BaseSwitch } from 'src/components/index';
	export default {
		name: 'ReActionInput',
		components: {
			BaseSwitch
		},
		props: {
			value: String,
			placeholder: String,
			masActions: Array,
			showBordes: {
				type: Boolean,
				default: false
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			DoApi(allAction){
				// console.log(allAction);
				if(this.$GVO.isEmpty(allAction.onClickApi)) return false;
				if(allAction.onClickApi.apiMethod == 'GOTO' && allAction.onClickApi.apiParam.obj == 'local'){
					this.$router.push({path: allAction.onClickApi.apiParam.to});
				}else{
					this.$GVO.ApiCall(allAction.onClickApi.apiMethod,allAction.onClickApi.apiParam)
					.then((objApi) => {
						// if(objApi.success === true){
							// console.log(objApi);
						// }
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			},
			DoAtt(allAction){
				// console.log(allAction);
			}
		},
	}
</script>
<style>
	.ReActionInput{
		display: flex;
		align-items: baseline;
		/*justify-content: space-between;*/
		padding: 0px 5px;
	}
	.ReActionInput.my_borders{
		border-bottom: 1px solid #01B0E0;
		padding: 5px 5px !important;
	}

	.ReActionInput input{min-width: 280px;}

	.ReActionInput .bootstrap-switch{width: 70px !important; margin: 0;}
	.ReActionInput .bootstrap-switch .bootstrap-switch-label{left: 55%;}
	.ReActionInput .bootstrap-switch-container{width: 106px !important;}
</style>
